module.exports = __webpack_public_path__ + "static/media/copy-gray.74ca1673.svg";